<div #portalAdminReactContainer class="superadmin"></div>